<template lang="pug">
.v-contacts-list.contacts-list
	v-loader(:loading="loading")
	.contacts-list__filters(v-if="contacts.filters")
		.contacts-list__filter(v-for="filter in contacts.filters" :key="filter.id")
			v-field(:field="filter"
					appearance="form"
					v-model="filter.value"
					@update:model-value="filterChanged")
	v-map(:coords="contacts.coordsMapCenter"
			:markers="contacts.items"
			:zoom="contacts.zoom"
			ref="map"
			:controls="contacts.controls"
			:right-controls="contacts.rightControls"
			@click-marker="openItem")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			contacts: {
				remote: null,
				coordsMapCenter: null,
				items: null,
				zoom: null
			}
		};
	},

	methods: {
		openItem(id) {
			let findItem = this.contacts.items.find(item => item.id === id);
			for (let i = 0; i < this.contacts.items.length; i++) {
				let currentItem = this.contacts.items[i];
				currentItem.active = currentItem.id === findItem.id;
			}
		},

		smoothScrollTo(endX, endY, duration) {
			let startX = window.scrollX || window.pageXOffset;
			let	startY = window.scrollY || window.pageYOffset;
			let distanceX = endX - startX;
			let distanceY = endY - startY;
			let startTime = new Date().getTime();
			let easeInOutQuart = function (time, from, distance, duration) {
				if ((time /= duration / 2) < 1) {
					return distance / 2 * time * time * time * time + from;
				}
				return -distance / 2 * ((time -= 2) * time * time * time - 2) + from;
			};
			let timer = window.setInterval(function () {
				let time = new Date().getTime() - startTime;
				let newX = easeInOutQuart(time, startX, distanceX, duration);
				let newY = easeInOutQuart(time, startY, distanceY, duration);
				if (time >= duration) {
					window.clearInterval(timer);
				}
				window.scrollTo(newX, newY);
			}, 1000 / 60); // 60 fps
		},

		shownOnMap(item, index) {
			for (let i = 0; i < this.contacts.items.length; i++) {
				let currentItem = this.contacts.items[i];
				if (currentItem.active !== index) {
					currentItem.active = false;
				}
			}
			item.active = true;
			this.$refs['map'].shownOnMap(item.coords);
			let top = this.$refs['map'].$el.getBoundingClientRect().top;
			const yOffset = -170;
			this.smoothScrollTo(0, top + window.pageYOffset + yOffset, 1000);
		},

		getFiltersValue() {
			let result = {};
			if (this.contacts && this.contacts.filters && this.contacts.filters.length > 0) {
				this.contacts.filters.forEach(filter => {
					result[filter.name] = {
						value: filter.value,
						type: filter.type
					};
				});
			}
			return result;
		},

		filterChanged() {
			this.dataLoad({
				url: this.contacts.remote,
				delay: true,
				data: {
					filters: this.getFiltersValue()
				}
			});
		},

		dataSet(data) {
			this.contacts = data;
			this.$nextTick(() => {
				this.$refs['map'].adjustBounds();
			});
		}
	}
};
</script>
